import { BlogCard } from './BlogCard';
import { BlogPost } from '@/types/blog';
import { useLanguage } from '@/hooks/useLanguage';
import { BlogGridSkeleton } from '../ui/Skeleton';

interface BlogGridProps {
  posts: BlogPost[];
  loading?: boolean;
  featuredFirst?: boolean;
  className?: string;
}

export function BlogGrid({ posts, loading, featuredFirst = false, className }: BlogGridProps) {
  const { t } = useLanguage();

  if (loading) {
    return <BlogGridSkeleton count={6} className={className} />;
  }

  if (posts.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="text-gray-500 text-lg">{t('common.noResults')}</div>
        <p className="text-gray-400 mt-2">
          No hay posts disponibles en este momento
        </p>
      </div>
    );
  }

  // Separate featured and regular posts
  const featuredPosts = posts.filter(post => post.featured);
  const regularPosts = posts.filter(post => !post.featured);

  // Organize posts based on featuredFirst setting
  const organizedPosts = featuredFirst 
    ? [...featuredPosts, ...regularPosts]
    : posts;

  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 ${className}`}>
      {organizedPosts.map((post, index) => (
        <BlogCard
          key={post.id}
          post={post}
          featured={featuredFirst && index === 0 && post.featured}
        />
      ))}
    </div>
  );
}